module.exports = __webpack_public_path__ + "01_bob_beige.bc227f17.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/01_bob_beige.png
// module id = mdkd
// module chunks = 0